import { combineReducers } from 'redux';
import mainReducer from '../components/main/reducer';
import widgetReducer from '../components/layers/widget/reducer';
import popupReducer from '../components/layers/popup/reducer';
import optionsReducer from './options/reducer';
import configReducer from './configuration/reducer';
import settingsReducer from './settings/reducer';
import preloaderReducer from '../components/views/preloader/reducer';
import chatReducer from '../components/views/chat/reducer';
import chatSaveReducer from '../components/views/save/reducer';
import cmbReducer from '../components/views/cmb/reducer';
import questionnaireReducer from '../components/views/questionnaire/reducer';
import callReducer from '../components/views/click2call/reducer';

export default combineReducers({
    main: mainReducer,
    widget: widgetReducer,
    popup: popupReducer,
    options: optionsReducer,
    config: configReducer,
    settings: settingsReducer,
    chat: chatReducer,
    chatSave: chatSaveReducer,
    cmb: cmbReducer,
    questionnaire: questionnaireReducer,
    preloader: preloaderReducer,
    call: callReducer
});
